import * as v from 'valibot';

// NOTE: mirrors CommandCenterMap-BE `ActivityBucketDto` / `ActivitySeriesDto` /
// `ActivityMonitoringDto` (src/app/http/admin/admin-activity.service.ts:53-89)
// — keep the two in sync. Every field MUST be declared: v.object strips
// undeclared keys silently, which is how TMDXNC-37 lost caseLabel/organ.

/**
 * One bucket of observed heartbeats.
 *
 * The series is SPARSE: only buckets with at least one observation appear, and
 * an ABSENT bucket is the gap the strip exists to show. Never zero-fill.
 */
export const activityBucketSchema = v.object({
  /** ISO 8601, floored to an epoch multiple of the bucket size. */
  start: v.string(),
  count: v.number(),
  /** Zero-count sources are OMITTED by the BE, so `{}` is legitimate. */
  bySource: v.record(v.string(), v.number()),
  /** Distinct non-null versions seen. Never contains null. */
  feVersions: v.array(v.string()),
  beVersions: v.array(v.string()),
  /** Rows whose feVersion was null — WS rows, or pre-TMDXNC-364 clients. */
  unknownFeVersionCount: v.number(),
  errorCount: v.number(),
});

export const activitySeriesSchema = v.object({
  oid: v.string(),
  /** Echoed NORMALISED to UTC — not byte-identical to what was sent. */
  from: v.string(),
  to: v.string(),
  bucketSeconds: v.number(),
  /** The build answering this request; AC8's BE half needs no other source. */
  deployedBeVersion: v.string(),
  buckets: v.array(activityBucketSchema),
});

/** What both toggle routes return — five fields, not the full AdminUserDto. */
export const activityMonitoringSchema = v.object({
  oid: v.string(),
  isActivityMonitored: v.boolean(),
  activityMonitoringReason: v.nullable(v.string()),
  activityMonitoringSetBy: v.nullable(v.string()),
  activityMonitoringExpiresAt: v.nullable(v.string()),
});
